require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-حماية-الخصوصية.json") })
        }
      }, "path---tags-حماية-الخصوصية");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-حماية-الخصوصية!./.cache/json/tags-حماية-الخصوصية.json
// module id = 603
// module chunks = 231608221292675